// extracted by mini-css-extract-plugin
export default {"container":"IndexNotificationsPanel_container__jHrVq"};